/**
 * Created by pc on 2018/12/25.
 */
import { get } from '@/agent/http/index';
const ACCOUNT_QUATYPE_MENU = 'ACCOUNT_QUATYPE_MENU'; // 资质类型下拉菜单
const ACCOUNT_INDUSTRY_MENU = 'ACCOUNT_INDUSTRY_MENU'; // 行业类型下拉菜单
const ACCOUNT_CIYTALL_MENU = 'ACCOUNT_CIYTALL_MENU'; // 省市区下拉菜单
const ACCOUNT_PUBLIC_BANK_MENU = 'ACCOUNT_PUBLIC_BANK_MENU'; // 对公银行下拉菜单
const state = {
  account: {
    quaTypeMenu: [],
    curQuaType: '',
    industryMenu: [],
    cityArr: [{ name: {} }],
    publicBankMenu: []
  }
};

const getters = {
  account: state => state.account
};

const actions = {
  getQualificationType ({ state, commit }) {
    get('/interface/etcd/item/' + 'qua_type').then(data => {
      if (data.code === 1) {
        commit(ACCOUNT_QUATYPE_MENU, data.data);
      }
    });
  },
  getIndustryType ({ state, commit }) {
    get('/interface/etcd/item/' + 'industry').then(data => {
      if (data.code === 1) {
        commit(ACCOUNT_INDUSTRY_MENU, data.data);
      }
    });
  },
  getPublicBankMenu ({ state, commit }) {
    get('/interface/etcd/item/' + 'bank_name').then(data => {
      if (data.code === 1) {
        commit(ACCOUNT_PUBLIC_BANK_MENU, data.data);
      }
    });
  },
  async getCityAll ({ state, commit }) {
    await get('/interface/etcd/item/' + 'china-area').then(data => {
      if (data.code === 1) {
        commit(ACCOUNT_CIYTALL_MENU, data.data);
      }
    });
  }
};

const mutations = {
  [ACCOUNT_QUATYPE_MENU] (state, data) {
    state.account.quaTypeMenu = data;
  },
  [ACCOUNT_PUBLIC_BANK_MENU] (state, data) {
    state.account.publicBankMenu = data;
  },
  [ACCOUNT_INDUSTRY_MENU] (state, data) {
    state.account.industryMenu = data;
  },
  [ACCOUNT_CIYTALL_MENU] (state, data) {
    state.account.cityArr = data;
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
